export default "__VITE_ASSET__CC_GS_rn__"